"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const patientGroupTranslation = {
    mrn: "MRN",
    mrnLabel: "Medical Record Number (MRN)",
    firstNameLabel: "Patient First Name",
    lastNameLabel: "Patient Last Name",
    dobLabel: "Patient DOB (MM/DD/YYYY)",
    phoneNumberLabel: "Patient Phone Number",
    addressField: {
        addressLabel: "Patient Address",
        addressInputPlaceholder: "Enter a patient address",
        addressButtonLabel: "Select address",
        selectFromSuggestions: "Select an address from the suggestions",
        noMatchTitle: "No matching address found",
        noMatchHint: "Try just street + city — enter the apartment or unit above.",
    },
    insuranceLabel: "Insurance",
    insuranceIconTooltip: "Patient Insurance",
    patientTagLabel: "Patient Tag",
    apartmentNumberLabel: "Apartment Number",
    aboutLabel: "About",
    referralInfoTitle: "Referral Information",
    pendingReferral: "Pending Referral",
    soc: "SOC",
    communityLiaisonHintLabel: "Community Liaison From EMR",
    communityLiaisonLabel: "Community Liaison",
    mrnNotFound: "MRN not found!",
    syncFromEMR: "Sync from EMR",
    emrSyncNotAvailable: "Contact Home Health Notify to enable EMR sync.",
    recentMRNsTitle: "Recent MRNs",
    noRecentMRNs: "No recent MRNs",
    referralSourceHintLabel: "Referral Source From EMR",
    referralSourceLabel: "Referral Source",
    addInfoTitle: "Add Info",
    phoneNumber: "Phone Number",
    fullNameLabel: "Full Name",
    physicianTitle: "Physician",
    physicianIconTooltip: "Physician Name",
    careGiverTitle: "Caregiver",
    pharmacyTitle: "Pharmacy",
    lupaTitle: "LUPA (1)",
    firstThirtyDays: "1st 30 days",
    secondThirtyDays: "2nd 30 days",
    referralFiles: "Referral Files",
    addCaption: "Add a caption",
    invalidFirstName: "Please enter patient first name",
    invalidLastName: "Please enter patient last name",
    invalidMrn: "Please enter the medical record number",
    invalidDateOfBirth: "Please select valid date of birth",
    emptyPhoneNumber: "Please enter phone number.",
    invalidPhoneNumber: "Phone number must be 10 digits.",
    invalidAddress: "Please select patient address.",
    socLabel: "Who will do SOC?",
    emptyFullName: "Please enter full name",
    tapToAddInList: "Tap here to add this in list",
    status: {
        nonAdmit: "Non Admit",
        pendingSoc: "Pending SOC",
        active: "Active",
        hospitalized: "Hospitalized",
        pendingRoc: "Pending ROC",
        discharged: "Discharged",
        invalid: "Invalid",
    },
    edit: {
        editGroup: "Edit Group",
        tabToAttachReferralInformation: "Tab to attach referral information",
        selectReferralInformationType: "Select Referral Information Type",
        documents: "Documents",
        images: "Images",
        chooseFromGallery: "Choose from gallery",
        takePhoto: "Take photo",
    },
};
exports.default = patientGroupTranslation;
